// eslint-disable-next-line import/prefer-default-export
export const phoneNumberRegex = /^[2-9]\d{2}-\d{3}-\d{4}$/;
